import i18n from '@/main';
import { mascaraCPF, mascaraCNPJ } from '@/utils/mascaras';

export const formatarCpfCnpj = cpfCnpj => {
    if (!cpfCnpj) return '';

    cpfCnpj = cpfCnpj.replace(/[\n\r]/g, '');

    const lista = cpfCnpj.split(',');
    if (lista.length > 1) return lista.map(formatarCpfCnpj).join(', ');

    cpfCnpj = cpfCnpj.replace(/\D/g, '');

    if (cpfCnpj.length === 11) return mascaraCPF(cpfCnpj);
    if (cpfCnpj.length === 14) return mascaraCNPJ(cpfCnpj);

    return cpfCnpj;
};

export const translate = key => i18n.t(`${key}`);

export const paginarArray = (array, itensPorPagina = 10) => {
    if (itensPorPagina === 1) {
        return [array];
    }
    return array.reduce((acc, _, index) => {
        if (index % itensPorPagina === 0) {
            acc.push(array.slice(index, index + itensPorPagina));
        }
        return acc;
    }, []);
};

export const ordenarArray = (array, chave, ordem) => {
    if (
        !['ascending', 'descending'].includes(ordem) ||
        !chave ||
        Object.keys(array).includes(chave)
    ) {
        return array;
    }
    return array.sort((a, b) => {
        const valorA = String(a[chave]) || '';
        const valorB = String(b[chave]) || '';

        return ordem === 'ascending'
            ? valorA.localeCompare(valorB, 'pt-BR')
            : valorB.localeCompare(valorA, 'pt-BR');
    });
};

export const obterStatusTraduzido = status => {
    switch (status) {
        case 'NAO_ENVIADO':
            return translate('denuncia.status.contratoNaoEnviado');
        case 'NAO_VISUALIZADO':
            return translate('denuncia.status.contratoNaoVisualizado');
        case 'VISUALIZADO':
            return translate('denuncia.status.contratoVisualizado');
        case 'EM_CADASTRAMENTO':
            return translate('denuncia.status.contratoEmCadastramento');
        case 'CONCLUIDO':
            return translate('denuncia.status.contratoConcluido');
        case 'ARQUIVADO':
            return translate('denuncia.status.contratoArquivado');
        default:
            return status;
    }
};

export const obterStatusTag = status => {
    switch (status) {
        case 'NAO_ENVIADO':
            return 'danger';
        case 'NAO_VISUALIZADO':
            return 'warning';
        case 'VISUALIZADO':
            return 'warning';
        case 'EM_CADASTRAMENTO':
            return 'warning';
        case 'CONCLUIDO':
            return 'success';
        case 'ARQUIVADO':
            return 'secondary';
        default:
            return 'light';
    }
};

export const obterStatus = status => ({
    status: obterStatusTraduzido(status),
    type: obterStatusTag(status)
});

export const formatarMensagemResultado = resultados => {
    const prePositivo = i18n.t('denuncia.view.labels.qtde_resultado_pref');
    const identificou = i18n.t(
        'denuncia.view.labels.qtde_resultado_identificou'
    );
    const sufPositivo = i18n.t('denuncia.view.labels.qtde_resultado_suf');
    const preNegativo = i18n.t('denuncia.view.labels.resultado_negativo_pref');
    const naoIdentificou = i18n.t(
        'denuncia.view.labels.resultado_negativo_nao_identificou'
    );
    const sufNegativo = i18n.t('denuncia.view.labels.resultado_negativo_suf');
    const mensagemPositivo = `${prePositivo} <b>${identificou}</b> ${resultados} ${sufPositivo}.`;
    const mensagemNegativo = `${preNegativo} <b>${naoIdentificou}</b> ${sufNegativo}.`;

    return resultados > 0 ? mensagemPositivo : mensagemNegativo;
};
